<template>
  <CDropdown
    inNav
    class="c-header-nav-items"
    placement="bottom-end"
    add-menu-classes="pt-0"
  >
    <template #toggler>
      <CHeaderNavLink>
        <div class="c-avatar">
          <img
            src="img/avatars/avatar-png-1.png"
            class="c-avatar-img "
          />
        </div>
      </CHeaderNavLink>
    </template>
    <CDropdownItem class="disabled">
      <CIcon name="cil-user" /> Profile
    </CDropdownItem>
    <CDropdownItem class="disabled">
      <CIcon name="cil-settings" /> Settings
    </CDropdownItem>
    <CDropdownItem @click="logout">
      <CIcon name="cil-lock-locked" /> Logout
    </CDropdownItem>
  </CDropdown>
</template>

<script>
import { auth } from '@/api'
import { isAuthenticated, logout } from '@/utils'

export default {
  name: 'TheHeaderDropdownAccnt',
  data () {
    return {
    }
  },
  methods: {
    logout(){
      auth.logout()
      this.$router.replace('/');
    }
  }
}
</script>

<style scoped>
  .c-icon {
    margin-right: 0.3rem;
  }
</style>
